import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { createFileRoute } from '@tanstack/react-router';
import { UserCheck } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/attestations')({
    component: AttestationsConfiguration,
    staticData: {
        metadata: {
            title: 'Attestations',
        },
        modules: ['attestations'],
        permissions: ['settings:update'],
        ui: {
            icon: UserCheck,
            widthVariant: 'default',
            title: 'Attestations configuration',
            subtitle: 'Manage attestation templates and schedules',
            menuDescription: 'Manage attestation templates and schedules',
        },
    },
});

function AttestationsConfiguration() {
    return (
        <PageController route={Route}>
            <Tabs
                items={[
                    {
                        label: 'User attestations',
                        to: '/console/$orgId/configuration/compliance/attestations/user-attestations',
                    },
                ]}
            />
        </PageController>
    );
}
